import script from "./Tabbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabbar.vue?vue&type=script&setup=true&lang=js"

import "./Tabbar.vue?vue&type=style&index=0&id=b8d374fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d374fa"]])

export default __exports__